export default "__VITE_ASSET__D8w3Ge0l__"